export enum ThreadedCommentsEmailCheckoutSteps {
    COLLECT,
    SUCCESS,
    DISMISS,
}
